module.exports = __webpack_public_path__ + "static/media/135U12_LivingRoom.af2ef225.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135U12_LivingRoom.jpg
// module id = 550
// module chunks = 0